<ng-container *ngIf="!init; else tourItemDisplay">
  <div class="loading">
    <mat-spinner
      style="margin: auto"
      color="primary"
      diameter="24"
    ></mat-spinner>
  </div>
</ng-container>
<ng-template #tourItemDisplay>
  <ng-container *ngIf="immoTask != null">
    <div class="ipad-tour-item-container">
      <div class="button-container">
        <div class="action-buttons">
          <div
            class="navigation-link clickable action-button waze-link"
            [class.navigation-link-disabled]="immoTask.address == null"
          >
            <img
              src="../../../../../../assets/waze-icon.png"
              width="30px"
              height="30px"
            />
            <a
              class="waze-link-margin"
              href="{{
                immoTask?.address?.line1
                  | wazeLink
                    : immoTask?.address?.city
                    : immoTask?.address?.postalCode
                    : immoTask?.address?.country
                    : immoTask?.address?.coordinates?.lat
                    : immoTask?.address?.coordinates?.lng
              }}"
              target="_blank"
              >Start navigatie</a
            >
          </div>

          <div class="placement-button">
            <button
              class="start-timer action-button clickable placement-button-height"
              [class.start-timer-disabled]="
                immoIPPlacerImmoTaskChangeStorageHandler
                  .currentImmoIPTaskChangesObject.executionStarted
              "
              [disabled]="
                immoIPPlacerImmoTaskChangeStorageHandler
                  .currentImmoIPTaskChangesObject.executionStarted
              "
              (click)="startExecution()"
            >
              <div class="d-flex">
                <mat-icon
                  [ngClass]="
                    immoIPPlacerImmoTaskChangeStorageHandler
                      .currentImmoIPTaskChangesObject.executionStarted
                      ? 'placement-started-schedule-icon'
                      : 'schedule-icon'
                  "
                  >schedule</mat-icon
                >
                <div class="start-text">
                  {{
                    immoIPPlacerImmoTaskChangeStorageHandler
                      .currentImmoIPTaskChangesObject.executionStarted
                      ? 'Uitvoering gestart'
                      : 'Start uitvoering'
                  }}
                </div>
              </div>
            </button>
          </div>
        </div>
        <div class="project-id align-right">
          <div>#{{ immoTask.id }}</div>
        </div>
      </div>

      <immo-ip-placer-immo-task-header
        [createdAtDateTime]="immoTask.createdAtDateTime"
        [name]="
          immoTask.requestingUser?.firstName
            | personName : immoTask.requestingUser?.lastName
        "
        [phoneNumber]="immoTask.requestingUser?.phone"
        [mobileNumber]="immoTask.requestingUser?.mobilePhoneNumber"
        [email]="immoTask.requestingUser?.email"
      ></immo-ip-placer-immo-task-header>

      <div class="upper-space tour-item-form-compartment base-project-info">
        <div class="d-flex">
          <div class="text-container no-space-between">
            <div>
              Onderwerp: <span class="strong">{{ immoTask.subject }}</span>
            </div>
            <div
              *ngIf="immoTask.description?.length > 0"
              class="upper-space preserve-new-line"
            >
              {{ immoTask.description }}
            </div>
          </div>
          <div class="asset-container ml-auto mr-0">
            <img
              *ngIf="designAssets?.length > 0"
              class="click-link max-summary-width max-summary-height"
              src="/api/assets/{{ designAssets[0].uuid }}"
              (click)="openLightbox('designAssets')"
            />
          </div>
        </div>
      </div>
      <div
        class="small-upper-space tour-item-form-compartment base-project-info"
      >
        <div class="d-flex">
          <div class="text-container no-space-between">
            <div
              *ngIf="immoTask.address != null"
              class="strong secondary-color"
            >
              <span>{{
                immoTask.address.line1
                  | printAddress
                    : immoTask.address.postalCode
                    : immoTask.address.city
              }}</span>
            </div>
            <div [class.upper-space]="immoTask.address != null">
              <div class="d-flex">
                <div>Atelier:&nbsp;</div>
                <div class="preserve-new-line">
                  <ng-container
                    *ngIf="!immoTask.needAtelier; else displayAtelierInfo"
                  >
                    Nee
                  </ng-container>
                  <ng-template #displayAtelierInfo>
                    {{
                      immoTask.atelierInfo?.length > 0
                        ? 'Ja, ' + immoTask.atelierInfo
                        : 'Ja'
                    }}
                  </ng-template>
                </div>
              </div>
              <div>
                <span>Gewenste uitvoeringsdatum: </span
                ><span class="strong">{{
                  immoTask.requestedDate
                    | formatASAPDate : immoTask.requestedASAP
                }}</span>
              </div>
            </div>
          </div>
          <div class="asset-container ml-auto mr-0">
            <img
              *ngIf="locationAssets?.length > 0"
              class="click-link max-summary-width max-summary-height"
              src="/api/assets/{{ locationAssets[0].uuid }}"
              (click)="openLightbox('locationAssets')"
            />
          </div>
        </div>
      </div>
      <div
        class="upper-space tour-item-form-compartment center-content divider-banner strong execution-header"
      >
        <div>
          Uitvoering: {{ placerName | joiner : ' - ' : planningDate }}
          <span *ngIf="immoTask.executionTime != null"
            >+
            <span class="secondary-color"
              >{{ immoTask.executionTime | slice : 0 : 5 }}u</span
            ></span
          >
        </div>
      </div>
      <div class="tour-item-form-compartment job-info job-info-execution">
        <div class="completion-container">
          <div class="d-flex w-100">
            <div class="completion-content-container">
              <div class="upper-space">
                <tour-item-registered
                  [tourItem]="immoTask.tourItem"
                ></tour-item-registered>
              </div>
              <div class="d-flex upper-space">
                <div class="align-textarea-label">
                  <div class="font-16 secondary-color strong">
                    Feedback installateur:
                  </div>
                </div>
                <div class="left-space flexer">
                  <textarea-input
                    [initContent]="immoTask.executionFeedback"
                    [placeholder]="'Heb je opmerkingen, noteer hier uw info'"
                    [client]="true"
                    (answer)="executionFeedbackChanged($event)"
                  ></textarea-input>
                </div>
              </div>
              <div class="to-do-item-container">
                <div class="d-flex">
                  <mat-checkbox
                    [disabled]="
                      !immoIPPlacerImmoTaskChangeStorageHandler
                        .currentImmoIPTaskChangesObject.executionStarted ||
                      immoTask.executed
                    "
                    [(ngModel)]="immoTask.completed.done"
                    (ngModelChange)="completedToDoItemChanged()"
                    ><span class="strong">Taak klaar</span></mat-checkbox
                  >
                  <div
                    *ngIf="immoTask.executedRegistration != null"
                    class="left-space align-with-to-do-item"
                  >
                    Uitgevoerd door
                    {{
                      immoTask.executedRegistration.by?.firstName
                        | personName
                          : immoTask.executedRegistration.by?.lastName
                    }}
                    -
                    {{
                      immoTask.executedRegistration.date
                        | formatDate : '' : 'dd/MM/yyyy - HH:mm'
                    }}
                  </div>
                </div>
              </div>
              <div *ngIf="immoTask.executed === false" class="upper-space">
                <div
                  class="reset-not-executed-link"
                  (click)="resetNotExecuted()"
                >
                  <mat-icon class="reset-not-executed-icon">close</mat-icon>
                  <span>Reset niet uitgevoerd</span>
                </div>
              </div>
            </div>
            <div class="completion-images-container more-upper-space d-flex">
              <div class="align-file-picker">
                <immo-ip-placer-immo-task-execution-assets
                  [assets]="executionAssets"
                  [disabled]="
                    !immoIPPlacerImmoTaskChangeStorageHandler
                      .currentImmoIPTaskChangesObject.executionStarted &&
                    immoTask.executed == null
                  "
                  [storingOfflineChange]="
                    immoIPPlacerImmoTaskChangeStorageHandler.isStoringOfflineChange ||
                    immoIPPlacerImmoTaskChangeStorageHandler.submitting ||
                    reloading
                  "
                  (assetsAdded)="offlineAssetsAdded($event)"
                  (assetDeleted)="assetWasDeleted($event)"
                ></immo-ip-placer-immo-task-execution-assets>
              </div>
            </div>
          </div>
        </div>
        <div class="float-right">
          <div class="d-flex">
            <ng-container
              *ngIf="
                immoIPPlacerImmoTaskChangeStorageHandler.isStoringOfflineChange ||
                immoIPPlacerImmoTaskChangeStorageHandler.submitting ||
                reloading
              "
            >
              <mat-spinner
                class="submitting-icon"
                color="primary"
                diameter="30"
              ></mat-spinner>
            </ng-container>
            <ng-container
              *ngIf="
                !immoIPPlacerImmoTaskChangeStorageHandler.isStoringOfflineChange &&
                !immoIPPlacerImmoTaskChangeStorageHandler.submitting &&
                !reloading
              "
            >
              <button
                *ngIf="immoTask.executed != null"
                mat-button
                class="button not-executed-button"
                (click)="submitChanges()"
              >
                Feedback wijziging opslaan
              </button>
              <button
                *ngIf="immoTask.executed == null"
                mat-button
                class="button not-executed-button"
                (click)="submitExecuted(false)"
              >
                Niet uitgevoerd
              </button>
              <button
                *ngIf="!immoTask.executed"
                mat-button
                class="button executed-button button-left-space"
                [disabled]="
                  !immoIPPlacerImmoTaskChangeStorageHandler
                    .currentImmoIPTaskChangesObject.executionStarted ||
                  !immoTask.completed?.done
                "
                (click)="submitExecuted(true)"
              >
                Uitgevoerd
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
